/* eslint-disable react/prop-types,jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import Modal from 'react-modal'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

// import autosize from "autosize";
import Axios from '../../../axios'

import StudentPickerRow from '../FacilityImpactReport/StudentPickerRow'
import BaseModal from '../../common/BaseModal'
import PlayerJourneyReportContainer from './PlayerJourneyReportContainer'

import placeholderIcon from '../../../assets/images/class-icon.png'
import ohSnap from '../../../assets/images/registration-coach/oh-snap.png'
import defaultProfilePic from '../../../assets/images/default_profile.png'

import './PlayerJourneyReport.scss'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

class PlayerJourneyReport extends React.Component {
  state = {
    studentModal: false,
    selectionDisplay: 'Students', // controls which subsection you're picking students from on the add student modal
    selectedStudents: [], // controlls actually adding students to the report
    temporarySelectedStudents: [], //conrolls adding students in the modal
    selectionFilter: '', // the searchbar on the studentModal
    reportLoader: false, // loader for when the report is being generated
    report: null, // the returned result from the report endpoint stored here
    studentLoader: true, // initial loader for bringing in students
    totalStudents: [], // from api - don't touch
    communityCourses: [], // from api - don't touch
    communityCompletedCourses: [], // from api - don't touch
    completedCourseLoader: true, // initial loader for bringing in completed courses
    courseLoader: true, // initial loader for bringing in courses
    familyLoader: true, // initial loader for bringing in families
    families: [], // from api - don't touch
    generalNoteModal: false,
    generalNote: '',
    errorModal: false, // if an error occurs requesting the report
    pdfLoader: false,
  }

  componentDidMount() {
    this._grabStudentsList(this.props.community.id).then(() => {
      this.setState({ studentLoader: false })
    })
    this._grabCourseList(this.props.community.id).then(() => {
      this.setState({ courseLoader: false })
    })
    this._grabCompletedCourseList(this.props.community.id).then(() => {
      this.setState({ completedCourseLoader: false })
    })
    this._grabFamilyList(this.props.community.id).then(() => {
      this.setState({ familyLoader: false })
    })
  }

  _grabStudentsList = async (community_id) => {
    const response = await Axios.get(
      `/api/v1/communities/${community_id}/students`
    )
    this.setState({ totalStudents: response.data.students })
  }

  _grabCourseList = async (community_id) => {
    const response = await Axios.get(
      `/api/v1/communities/${community_id}/coach_courses`
    )
    this.setState({ communityCourses: response.data.courses })
  }

  _grabCompletedCourseList = async (community_id) => {
    const response = await Axios.get(
      `/api/v1/communities/${community_id}/completed_courses`
    )
    this.setState({ communityCompletedCourses: response.data.courses })
  }

  _grabFamilyList = async (community_id) => {
    const response = await Axios.get(
      `/api/v1/communities/${community_id}/families`
    )
    this.setState({ families: response.data.families })
  }

  // eslint-disable-next-line max-lines-per-function
  render() {
    const { goBack, t } = this.props
    const {
      studentModal,
      selectedStudents,
      temporarySelectedStudents,
      selectionDisplay,
      selectionFilter,
      generalNoteModal,
      generalNote,
      report,
      reportModal,
      reportLoader,
      errorModal,
      pdfLoader,
    } = this.state
    if (report && reportModal) {
      return (
        <div className='w-100 h-100 pt-3 pb-3 report-display-container'>
          <div className='redownload-bar'>
            <div className='d-flex align-items-center justify-content-center w-50 mx-auto'>
              <button
                className='btn-rectangular btn-rectangular-main'
                onClick={this._convertReportToPDF}
                disabled={pdfLoader}
              >
                {pdfLoader ? (
                  <div className='d-flex align-items-center justify-content-center'>
                    <i
                      className='fa fa-spinner fa-spin mr-2'
                      aria-hidden='true'
                    />
                    {t('reports.common.loadingReport')}
                    <i
                      className='fa fa-spinner fa-spin ml-2'
                      aria-hidden='true'
                    />
                  </div>
                ) : (
                  <div className='d-flex align-items-center justify-content-center'>
                    <i className='fa fa-file-pdf-o mr-2' aria-hidden='true' />
                    {t('reports.common.downloadReport')}
                    <i className='fa fa-file-pdf-o ml-2' aria-hidden='true' />
                  </div>
                )}
              </button>
            </div>
          </div>
          <p
            className='back-to-previous'
            onClick={() => this.setState({ reportModal: false })}
          >
            <i className='fa fa-arrow-left' aria-hidden='true' />
            {t('common.action.goBack')}
          </p>
          <PlayerJourneyReportContainer
            reports={report}
            selectedStudents={selectedStudents}
          />
        </div>
      )
    }
    return (
      <div id='PlayerJourneyReport'>
        <div className='impact-top-bar'>
          <i className='fa fa-arrow-left' aria-hidden='true' onClick={goBack} />
          <div className='top-bar-title-container'>
            <h3>{t('reports.playerJourney.title')}</h3>
            <p className='title-description'>
              {t('reports.playerJourney.titleDescription')}
            </p>
          </div>
          <div className='impact-video-trigger-container pjr-trigger'>
            <i className='fa fa-play-circle-o' aria-hidden='true' />
            <p>{t('reports.playerJourney.needHelp')}</p>
          </div>
        </div>
        <div className='player-journey-main d-flex flex-column'>
          <h4>
            {t('reports.playerJourney.step1Heading')}
          </h4>
          {selectedStudents.length === 0 ? (
            <div className='student-placeholder-container'>
              <div
                className='placeholder-icon'
                style={{ backgroundImage: `url(${placeholderIcon})` }}
              />
              <p className='bold'>{t('reports.playerJourney.noStudentsSelectedYetBold')}</p>
              <p>{t('reports.playerJourney.pleaseSelectStudentsToGenerate')}</p>
              <div>
                <button
                  className='btn-rectangular btn-rectangular-main-positive'
                  onClick={this._openStudentModal}
                >
                  {t('reports.playerJourney.selectStudentsToInclude')}
                </button>
              </div>
            </div>
          ) : (
            <div className='student-note-container'>
              <div className='d-flex justify-content-between'>
                <p className='mb-0 bold'>
                  {t('reports.playerJourney.selectedStudentsCount', {
                    count: selectedStudents.length,
                  })}
                </p>
                <div
                  className='d-flex orange-text flex-nowrap align-items-center clickable'
                  onClick={this._openStudentModal}
                >
                  <i
                    className='fa fa-pencil-square-o mr-1'
                    aria-hidden='true'
                  />
                  <p className='mb-0'>{t('reports.playerJourney.editStudentSelection')}</p>
                </div>
              </div>
              <div className='student-table-head'>
                <div className='left-table'>
                  <p className='head-text-title'>{t('reports.playerJourney.studentColumn')}</p>
                </div>
                <div className='right-table'>
                  <p className='head-text-title'>{t('reports.playerJourney.noteFromCoachOptional')}</p>
                  <p className='head-text'>
                    {t('reports.playerJourney.noteInstructions')}
                  </p>
                  <div className='d-flex orange-text mt-2'>
                    <div
                      className='d-flex clickable align-items-center mr-4'
                      onClick={this._toggleGeneralNoteModal}
                    >
                      <i className='fa fa-file-o mr-1' aria-hidden='true' />
                      <p>{t('reports.playerJourney.enterGeneralNoteForAll')}</p>
                    </div>
                    <div
                      className='d-flex clickable align-items-center'
                      onClick={this._clearAllNotes}
                    >
                      <i className='fa fa-trash-o mr-1' aria-hidden='true' />
                      <p>{t('reports.playerJourney.clearAllNotes')}</p>
                    </div>
                  </div>
                </div>
              </div>
              {selectedStudents.map((student) => (
                <div key={student.id} className='student-row'>
                  <div className='left-table row-left'>
                    <div
                      className='player-icon'
                      style={{
                        backgroundImage: `url(${
                          student.avatar
                            ? student.avatar.file_url
                            : defaultProfilePic
                        })`,
                      }}
                    />
                    <div className='d-flex flex-column'>
                      <p className='row-name'>{student.name}</p>
                      <p className='row-username'>{student.username}</p>
                    </div>
                  </div>
                  <div className='right-table row-right'>
                    <textarea
                      className='student-note'
                      placeholder={t(
                        'reports.playerJourney.addNoteForStudentPlaceholder',
                        { firstName: student.name.split(' ')[0] }
                      )}
                      value={student.note}
                      onChange={(e) =>
                        this._handleStudentNoteChange(e, student.id)
                      }
                    />
                    <p className='word-count'>
                      {t('reports.playerJourney.charCount300', {
                        count: student.note.length,
                      })}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className='impact-report-bottom-bar'>
          {report ? (
            <button
              className='btn-rectangular btn-rectangular-main-positive'
              onClick={this._reopenReport}
            >
              {t('reports.common.viewReport')}
            </button>
          ) : (
            <button
              className='btn-rectangular btn-rectangular-main-positive grab-report-button'
              disabled={this._checkValidation()}
              onClick={this._grabReportData}
            >
              {t('reports.playerJourney.step2Generate')}
            </button>
          )}
        </div>
        {errorModal && (
          <BaseModal
            close={() => false}
            backable={false}
            hideClose={true}
            width='350px'
          >
            <div id='impact-report-error-modal'>
              <div
                className='oh-snap'
                style={{ backgroundImage: `url(${ohSnap})` }}
              />
              <p className='main-text text-center'>{t('reports.playerJourney.somethingWentWrong')}</p>
              <p className='sub-text text-center'>
                {t('reports.playerJourney.errorSubText')}
              </p>
              <button
                className='btn-rectangular btn-rectangular-main'
                onClick={() => this.setState({ errorModal: false })}
              >
                {t('common.close')}
              </button>
            </div>
          </BaseModal>
        )}
        {reportLoader && (
          <BaseModal
            close={() => false}
            backable={false}
            hideClose={true}
            width='350px'
          >
            <div id='impact-report-loading-modal'>
              <i className='fa fa-spinner fa-spin' aria-hidden='true' />
              <p className='main-text text-center'>{t('reports.playerJourney.generatingReport')}</p>
              <p className='sub-text text-center'>
                {t('reports.playerJourney.generatingReportSubText')}
              </p>
            </div>
          </BaseModal>
        )}
        {generalNoteModal && (
          <BaseModal
            close={this._toggleGeneralNoteModal}
            hideClose={true}
            width={'50vw'}
          >
            <h4 className='text-center'>{t('reports.playerJourney.enterGeneralNoteForAll')}</h4>
            <p className='text-center' style={{ color: '#5f6f7c' }}>
              {t('reports.playerJourney.generalNoteModalDescription')}
            </p>
            <textarea
              className='player-journey-general-note-input'
              value={generalNote}
              onChange={this._handleGeneralNoteChange}
              placeholder={t('reports.playerJourney.enterGeneralNotePlaceholder')}
            ></textarea>
            <p className='text-right' style={{ color: '#AFB7BD' }}>
              {t('reports.playerJourney.charCount300Characters', {
                count: generalNote.length,
              })}
            </p>
            <div className='d-flex'>
              <div style={{ flex: '1 1' }}>
                <button
                  className='btn-rectangular btn-rectangular-main-negative'
                  onClick={this._toggleGeneralNoteModal}
                >
                  {t('reports.playerJourney.cancel')}
                </button>
              </div>
              <div style={{ flex: '1 1' }}>
                <button
                  className='btn-rectangular btn-rectangular-main-positive'
                  onClick={this._applyGeneralNote}
                >
                  {t('reports.playerJourney.applyNoteToAllStudents')}
                </button>
              </div>
            </div>
          </BaseModal>
        )}
        <Modal
          isOpen={studentModal}
          contentLabel={t('reports.playerJourney.addStudentModalContentLabel')}
          shouldCloseOnOverlayClick
          className='customModal'
        >
          <div id='add-student-to-report-modal'>
            <div className='modal-header'>
              <h5 className='modal-title display-4'>{t('reports.playerJourney.selectStudents')}</h5>
              <div className='col-1'>
                <button
                  type='button'
                  className='close pull-right font-200'
                  data-dismiss='modal'
                  aria-label={t('common.close')}
                  onClick={this._closeUnsavedStudentModal}
                >
                  <span aria-hidden='true'>✕</span>
                </button>
              </div>
            </div>
            <div className='student-modal-content'>
              <div className='selector-section'>
                <div className='top-selector-bar'>
                  <div
                    className='selection-container'
                    onClick={() => this._switchDisplay('Students')}
                  >
                    <p
                      className={`${
                        selectionDisplay === 'Students' ? 'isActive' : ''
                      }`}
                    >
                      {t('reports.playerJourney.tabStudents')}
                    </p>
                  </div>
                  <div
                    className='selection-container'
                    onClick={() => this._switchDisplay('Families')}
                  >
                    <p
                      className={`${
                        selectionDisplay === 'Families' ? 'isActive' : ''
                      }`}
                    >
                      {t('reports.playerJourney.tabFamilies')}
                    </p>
                  </div>
                  <div
                    className='selection-container'
                    onClick={() => this._switchDisplay('Active Classes')}
                  >
                    <p
                      className={`${
                        selectionDisplay === 'Active Classes' ? 'isActive' : ''
                      }`}
                    >
                      {t('reports.playerJourney.tabActiveClasses')}
                    </p>
                  </div>
                  <div
                    className='selection-container'
                    onClick={() => this._switchDisplay('Completed Classes')}
                  >
                    <p
                      className={`${
                        selectionDisplay === 'Completed Classes'
                          ? 'isActive'
                          : ''
                      }`}
                    >
                      {t('reports.playerJourney.tabCompletedClasses')}
                    </p>
                  </div>
                  <div
                    className='selection-indicator'
                    style={this._grabLeftCoordinate()}
                  />
                </div>
                <div className='d-flex align-items-center justify-content-between mt-5'>
                  <h4>{this._selectionDisplayLabel(selectionDisplay)}</h4>
                  <div className='icon-search-bar'>
                    <i className='fa fa-search' aria-hidden='true' />
                    <input
                      name='selectionFilter'
                      onChange={this._onInputChange}
                      value={selectionFilter}
                      placeholder={t('reports.playerJourney.searchSelection', {
                        selectionDisplay:
                          this._selectionDisplayLabel(selectionDisplay),
                      })}
                      disabled={this._checkSearchLoading(selectionDisplay)}
                    />
                  </div>
                </div>
                <div className='picker-selection-display'>
                  {this._renderPicker()}
                </div>
              </div>
              {temporarySelectedStudents.length < 1 ? (
                <div className='placeholder-container d-flex align-items-center justify-content-center flex-column'>
                  <div
                    className='placeholder-icon'
                    style={{ backgroundImage: `url(${placeholderIcon})` }}
                  />
                  <p className='bold'>{t('reports.playerJourney.noStudentsSelectedYet')}</p>
                  <p>
                    {t('reports.playerJourney.pleaseSelectStudentsBySelecting')}
                  </p>
                </div>
              ) : (
                <div className='student-display-section'>
                  <div className='inner-display'>
                    <p className='bold section-title'>
                      {t('reports.playerJourney.selectedStudentsCount', {
                        count: temporarySelectedStudents.length,
                      })}
                    </p>
                    <div className='student-box'>
                      {temporarySelectedStudents.map((student) => (
                        <StudentPickerRow
                          key={student.id}
                          student={student}
                          clickable
                          onClick={this._removeStudentFromTemporary}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-8 mx-auto'>
              <button
                className='btn-rectangular btn-rectangular-main'
                onClick={this._closeSavedStudentModal}
              >
                {t('reports.playerJourney.confirmSelection')}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }

  _reopenReport = () => {
    this.setState({ reportModal: true })
  }

  _grabReportData = () => {
    this.setState({ reportLoader: true }, async () => {
      const { selectedStudents } = this.state
      try {
        let requestUrl = '/api/v1/reports/player_journey_progress'
        selectedStudents.forEach((student, i) => {
          requestUrl += `${i === 0 ? '?' : '&'}user_ids[]=${student.id}`
        })
        const response = await Axios.get(requestUrl)
        this.setState({ report: response.data }, () => {
          this.setState(
            { reportLoader: false, reportModal: true, pdfLoader: false },
            () => {
              //setTimeout(this._convertReportToPDF, 1000);
            }
          )
          this.setState({ reportLoader: false })
        })
      } catch (err) {
        this.setState({ reportLoader: false, errorModal: true })
      }
    })
  }

  _convertReportToPDF = () => {
    this.setState({ pdfLoader: true }, async () => {
      const ORIENTATION = 'landscape'
      const UNIT = 'px'

      const reportPages = document.querySelectorAll('.PlayerJourneyReportView')

      const pageWidth =
        (reportPages && reportPages[0] && reportPages[0].clientWidth) || 1000
      const pageHeight =
        (reportPages && reportPages[0] && reportPages[0].clientHeight) || 780

      const pdf = new jsPDF({
        orientation: ORIENTATION,
        unit: UNIT,
        format: [pageWidth, pageHeight],
        hotfixes: ['px_scaling'],
      })

      for (let i = 0; i < reportPages.length; i++) {
        const canvas = await html2canvas(reportPages[i], {
          useCORS: true,
          logging: true,
        })
        if (i > 0) { pdf.addPage([pageWidth, pageHeight]) }
        const imgData = canvas.toDataURL('image/png', 1.0)
        pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight, '', 'FAST')
      }

      await pdf.save('player_journey_reports.pdf')
      this.setState({ pdfLoader: false })
    })
  }

  _handleGeneralNoteChange = (e) => {
    const generalNote = e.target.value
    if (generalNote.length > 300) { return false }
    this.setState({ generalNote })
  }

  _toggleGeneralNoteModal = () => {
    this.setState((prevState) => ({ generalNoteModal: !prevState.generalNoteModal }))
  }

  _applyGeneralNote = () => {
    const { selectedStudents, generalNote } = this.state
    const selectedStudentsCopy = [...selectedStudents]
    selectedStudentsCopy.map((s) => {
      s.note = generalNote
      return s
    })
    this.setState(
      { selectedStudents: selectedStudentsCopy, report: null },
      () => {
        this._toggleGeneralNoteModal()
      }
    )
  }

  _clearAllNotes = () => {
    const { selectedStudents } = this.state
    const selectedStudentsCopy = [...selectedStudents]
    selectedStudentsCopy.map((s) => {
      s.note = ''
      return s
    })
    this.setState({ selectedStudents: selectedStudentsCopy, report: null })
  }

  _handleStudentNoteChange = (e, studentId) => {
    const fullNote = e.target.value
    if (fullNote.length > 300) {
      return false
    }
    const { selectedStudents } = this.state
    const selectedStudentsCopy = [...selectedStudents]
    const changingStudent = selectedStudentsCopy.find((s) => s.id === studentId)
    changingStudent.note = fullNote
    this.setState({ selectedStudents: selectedStudentsCopy, report: null })
  }

  _openStudentModal = () => {
    this.setState({ studentModal: true })
  }

  _closeUnsavedStudentModal = () => {
    const { selectedStudents } = this.state
    this.setState({ temporarySelectedStudents: [...selectedStudents] }, () => {
      this.setState({ studentModal: false })
    })
  }

  _switchDisplay = (val) => {
    const { selectionDisplay } = this.state
    if (val === selectionDisplay) { return false }
    this.setState({ selectionFilter: '' }, () => {
      this.setState({ selectionDisplay: val })
    })
  }

  _selectionDisplayLabel = (selectionDisplay) => {
    const { t } = this.props
    switch (selectionDisplay) {
      case 'Families':
        return t('reports.playerJourney.selectionFamilies')
      case 'Active Classes':
        return t('reports.playerJourney.selectionActiveClasses')
      case 'Completed Classes':
        return t('reports.playerJourney.selectionCompletedClasses')
      case 'Students':
      default:
        return t('reports.playerJourney.selectionStudents')
    }
  }

  _grabLeftCoordinate = () => {
    const { selectionDisplay } = this.state
    switch (selectionDisplay) {
      case 'Families':
        return { left: '25%' }
      case 'Active Classes':
        return { left: '50%' }
      case 'Completed Classes':
        return { left: '75%' }
      default:
        return { left: 0 }
    }
  }

  _checkAlreadySelected = (users) => {
    if (users.length === 0) { return false }
    const { temporarySelectedStudents } = this.state
    return users.every((user) =>
      temporarySelectedStudents.map((u) => u.id).includes(user.id)
    )
  }

  _onInputChange = (event) => {
    const name = event.target.name
    const value = event.target.value
    if (name === 'membershipPercent' && value.length > 3) {
      return false
    }
    this.setState({ [name]: value })
  }

  _checkSearchLoading = (current) => {
    const { studentLoader, courseLoader, completedCourseLoader, familyLoader } =
      this.state
    switch (current) {
      case 'Students':
        return studentLoader
      case 'Families':
        return familyLoader
      case 'Active Classes':
        return courseLoader
      case 'Completed Classes':
        return completedCourseLoader
      default:
        return true
    }
  }

  _checkValidation = () => {
    //return true to fail validation and false to pass
    const { selectedStudents } = this.state
    if (selectedStudents.length < 1) { return true }
    return false
  }

  _renderPicker = () => {
    const { selectionDisplay, selectionFilter } = this.state
    switch (selectionDisplay) {
      case 'Active Classes':
        return this._renderClasses(selectionFilter)
      case 'Completed Classes':
        return this._renderCompletedClasses(selectionFilter)
      case 'Families':
        return this._renderFamilies(selectionFilter)
      case 'Students':
        return this._renderStudents(selectionFilter)
      default:
        return null
    }
  }

  _renderClasses = (filter) => {
    const { t } = this.props
    const { courseLoader, communityCourses } = this.state
    if (courseLoader) {
      return (
        <div className='d-flex flex-column align-items-center justify-content-center pt-3'>
          <i className='fa fa-spinner fa-spin' aria-hidden='true' />
          <p className='mt-3'>{t('reports.playerJourney.loadingActiveClasses')}</p>
        </div>
      )
    }
    if (communityCourses.length < 1) {
      return (
        <div className='d-flex justify-content-center mt-3'>
          <p>{t('reports.playerJourney.noActiveClasses')}</p>
        </div>
      )
    }
    return communityCourses
      .filter((c) => {
        if (!filter || filter.split('').every((char) => char === ' ')) { return true }
        return c.name.toLowerCase().includes(filter.trim().toLowerCase())
      })
      .map((course) => {
        const alreadySelected = this._checkAlreadySelected(
          course.enrollments
            .filter((e) => e.status === 'active')
            .map((e) => e.user)
        )
        const enrollmentCount = course.enrollments.filter(
          (e) => e.status === 'active'
        ).length
        return (
          <div
            key={course.id}
            className={`class-row ${
              alreadySelected || enrollmentCount === 0 ? '' : 'clickable'
            }`}
            onClick={() =>
              this._addStudentArray(
                this._pullStudentsFromCourse(course, 'active')
              )
            }
          >
            <div
              className='class-icon'
              style={{
                backgroundImage: `url(${
                  course.photo
                    ? course.photo.file_url
                    : course.lesson_plan && course.lesson_plan.photo
                      ? course.lesson_plan.photo.file_url
                      : placeholderIcon
                })`,
              }}
            />
            <div className='name-area'>
              <p className='name'>{course.name}</p>
              <p className='meeting-times'>
                {course.meeting_times}{' '}
                <span className='#ff6633'>
                  {t('reports.playerJourney.studentCount', {
                    count: enrollmentCount,
                  })}
                </span>
              </p>
            </div>
            {alreadySelected ? (
              <i className='fa fa-check-circle' aria-hidden='true' />
            ) : (
              <i className='fa fa-plus' aria-hidden='true' />
            )}
          </div>
        )
      })
  }

  _renderCompletedClasses = (filter) => {
    const { t } = this.props
    const { completedCourseLoader, communityCompletedCourses } = this.state
    if (completedCourseLoader) {
      return (
        <div className='d-flex flex-column align-items-center justify-content-center pt-3'>
          <i className='fa fa-spinner fa-spin' aria-hidden='true' />
          <p className='mt-3'>{t('reports.playerJourney.loadingCompletedClasses')}</p>
        </div>
      )
    }
    if (communityCompletedCourses.length < 1) {
      return (
        <div className='d-flex justify-content-center mt-3'>
          <p>{t('reports.playerJourney.noCompletedClasses')}</p>
        </div>
      )
    }
    return communityCompletedCourses
      .filter((c) => {
        if (!filter || filter.split('').every((char) => char === ' ')) { return true }
        return c.name.toLowerCase().includes(filter.trim().toLowerCase())
      })
      .map((course) => {
        const alreadySelected = this._checkAlreadySelected(
          course.enrollments
            .filter((e) => e.status === 'completed')
            .map((e) => e.user)
        )
        const enrollmentCount = course.enrollments.filter(
          (e) => e.status === 'completed'
        ).length
        return (
          <div
            key={course.id}
            className={`class-row ${
              alreadySelected || enrollmentCount === 0 ? '' : 'clickable'
            }`}
            onClick={() =>
              this._addStudentArray(
                this._pullStudentsFromCourse(course, 'completed')
              )
            }
          >
            <div
              className='class-icon'
              style={{
                backgroundImage: `url(${
                  course.photo
                    ? course.photo.file_url
                    : course.lesson_plan && course.lesson_plan.photo
                      ? course.lesson_plan.photo.file_url
                      : placeholderIcon
                })`,
              }}
            />
            <div className='name-area'>
              <p className='name'>
                {course.name}{' '}
                <span className='completed-range'>{`(${moment(
                  course.start_date
                ).format('L')} - ${moment(course.end_date).format(
                  'L'
                )})`}</span>
              </p>
              <p className='meeting-times'>
                {course.meeting_times}{' '}
                <span className='#ff6633'>
                  {t('reports.playerJourney.studentCount', {
                    count: enrollmentCount,
                  })}
                </span>
              </p>
            </div>
            {alreadySelected ? (
              <i className='fa fa-check-circle' aria-hidden='true' />
            ) : (
              <i className='fa fa-plus' aria-hidden='true' />
            )}
          </div>
        )
      })
  }

  _renderFamilies = (filter) => {
    const { t } = this.props
    const { familyLoader, families } = this.state
    if (familyLoader) {
      return (
        <div className='d-flex flex-column align-items-center justify-content-center pt-3'>
          <i className='fa fa-spinner fa-spin' aria-hidden='true' />
          <p className='mt-3'>{t('reports.playerJourney.loadingFamilies')}</p>
        </div>
      )
    }
    if (families.lentgh < 1) {
      return (
        <div className='d-flex justify-content-center mt-3'>
          <p>{t('reports.playerJourney.noFamiliesFound')}</p>
        </div>
      )
    }
    return families
      .filter((f) => {
        if (!filter || filter.split('').every((char) => char === ' ')) { return true }
        return f.name.toLowerCase().includes(filter.trim().toLowerCase())
      })
      .map((family) => {
        const studentCount = family.users.filter((u) => u.is_golfer).length
        const alreadySelected = this._checkAlreadySelected(
          family.users.filter((u) => u.is_golfer)
        )
        return (
          <div
            key={family.id}
            className={`family-row1 ${
              alreadySelected || studentCount === 0 ? '' : 'clickable'
            }`}
            onClick={() =>
              this._addStudentArray(this._pullStudentsFromFamily(family))
            }
          >
            <i className='fa fa-users' aria-hidden='true' />
            <div className='name-area'>
              <p className='name'>{family.name}</p>
              <p className='student-count'>
                {t('reports.playerJourney.studentCount', {
                  count: studentCount,
                })}
              </p>
            </div>
            {alreadySelected ? (
              <i className='fa fa-check-circle' aria-hidden='true' />
            ) : (
              <i className='fa fa-plus' aria-hidden='true' />
            )}
          </div>
        )
      })
  }

  _renderStudents = (filter) => {
    const { t } = this.props
    const { temporarySelectedStudents, totalStudents, studentLoader } =
      this.state
    if (studentLoader) {
      return (
        <div className='d-flex flex-column align-items-center justify-content-center pt-3'>
          <i className='fa fa-spinner fa-spin' aria-hidden='true' />
          <p className='mt-3'>{t('reports.common.loadingStudents')}</p>
        </div>
      )
    }
    if (totalStudents.length < 1) {
      return (
        <div className='d-flex justify-content-center mt-3'>
          <p>{t('reports.playerJourney.needStudentsForReport')}</p>
        </div>
      )
    }
    return totalStudents
      .filter((s) => {
        if (!filter || filter.split('').every((char) => char === ' ')) { return true }
        return (
          s.first_name?.toLowerCase().includes(filter.trim().toLowerCase()) ||
          s.last_name?.toLowerCase().includes(filter.trim().toLowerCase())
        )
      })
      .map((student) => {
        const alreadySelected = temporarySelectedStudents
          .map((s) => s.id)
          .includes(student.id)
        return (
          <div
            key={student.id}
            className={`student-row ${alreadySelected ? '' : 'clickable'}`}
            onClick={() => this._addStudent(this._formatStudentData(student))}
          >
            <div
              className='avatar'
              style={{
                backgroundImage: `url(${
                  student.avatar ? student.avatar.file_url : defaultProfilePic
                })`,
              }}
            />
            <div className='name-area'>
              <p className='name'>{`${student.first_name} ${student.last_name}`}</p>
              <p className='login'>{student.email || student.username}</p>
            </div>
            {alreadySelected ? (
              <i className='fa fa-check-circle' aria-hidden='true' />
            ) : (
              <i className='fa fa-plus' aria-hidden='true' />
            )}
          </div>
        )
      })
  }

  _removeStudentFromTemporary = (student_id) => {
    this.setState((prevState) => ({
      temporarySelectedStudents: prevState.temporarySelectedStudents.filter(
        (s) => s.id !== student_id
      ),
    }))
  }

  _closeSavedStudentModal = () => {
    const { temporarySelectedStudents, selectedStudents, report } = this.state
    const obj = { selectedStudents: [...temporarySelectedStudents] }
    if (
      report &&
      this._checkNotSame(temporarySelectedStudents, selectedStudents)
    ) {
      obj['report'] = null
    }
    this.setState(obj, () => {
      this.setState({ studentModal: false })
    })
  }

  _checkNotSame = (one, two) => {
    // checks if arrays hold the same students
    if (one.length !== two.length) { return true }
    const sameValues = one.every((val) => two.map((v) => v.id).includes(val.id))
    return !sameValues
  }

  _pullStudentsFromFamily = (family) => family.users
    .filter((user) => user.is_golfer)
    .map((user) => this._formatStudentData(user))

  _pullStudentsFromCourse = (course, status) => course.enrollments
    .filter((enrollment) => enrollment.status === status)
    .map((enrollment) => this._formatStudentData(enrollment.user))

  _formatStudentData = (student) => ({
    id: student.id,
    name: `${student.first_name} ${student.last_name}`,
    username: student.username || student.email,
    avatar: student.avatar,
    note: '',
  })

  _addStudent = (student) => {
    this.setState((prevState) => {
      if (
        prevState.temporarySelectedStudents
          .map((s) => s.id)
          .includes(student.id)
      ) {
        return prevState
      }
      return {
        temporarySelectedStudents: [
          ...prevState.temporarySelectedStudents,
          student,
        ],
      }
    })
  }

  _addStudentArray = (students) => {
    this.setState((prevState) => {
      const studentsToAdd = students.filter(
        (s1) =>
          !prevState.temporarySelectedStudents
            .map((s2) => s2.id)
            .includes(s1.id)
      )
      return {
        temporarySelectedStudents: [
          ...prevState.temporarySelectedStudents,
          ...studentsToAdd,
        ],
      }
    })
  }

  _removeStudentFromSelected = (student_id) => {
    this.setState((prevState) => {
      const newList = prevState.selectedStudents.filter(
        (s) => s.id !== student_id
      )
      return {
        selectedStudents: [...newList],
        temporarySelectedStudents: [...newList],
      }
    })
  }
}

export default withTranslation()(PlayerJourneyReport)
